import Api from '../modules/Api.js'

/* ---- RADIO ---- */

export const setAutoplay = (val = false) => {
  return {
    type: 'SET_AUTOPLAY',
    value: val
  }
}
export const setPlayback = (n = 0) => {
  return {
    type: 'SET_PLAYBACK',
    value: n
  }
}

export const playPause = () => {
  return {
    type: 'PLAY_PAUSE'
  }
}

export const playNext = () => {
  return {
    type: 'PLAY_NEXT'
  }
}

export const mute = () => {
  return {
    type: 'MUTE'
  }
}

export const playTrack = (index) => {
  return {
    type: 'PLAY_TRACK',
    value: index
  }
}

export const playNextPlaylist = (data) => {
  return function (dispatch) {
    const apiCall = new Api()
    return apiCall.getTracks(data.uid).then(result => {
      dispatch(updateTracks(result.response))
    }).catch(error => {
      throw (error)
    })
  }
}

export const updatePlaylists = (data) => {
  return {
    type: 'UPDATE_PLAYLISTS',
    value: data
  }
}

export const updateTracks = (data) => {
  return {
    type: 'LOAD_TRACKS',
    value: data
  }
}

export const getTracks = (uid) => {
  return function (dispatch) {
    const apiCall = new Api()
    return apiCall.getPage('tracks', uid).then(result => {
      dispatch(updateTracks(result.response))
    }).catch(error => {
      throw (error)
    })
  }
}

export const updateCurrentTime = (time) => {
  return {
    type: 'UPDATE_CURRENTTIME',
    value: time
  }
}

export const updateDuration = (time) => {
  return {
    type: 'UPDATE_DURATION',
    value: time
  }
}

export const updateProgress = (n) => {
  return {
    type: 'UPDATE_PROGRESS',
    value: n
  }
}

export const scrubbingOn = () => {
  return {
    type: 'SCRUBBING_ON'
  }
}

export const scrubbingOff = () => {
  return {
    type: 'SCRUBBING_OFF'
  }
}

/* ---- BACKGROUND ---- */

export const updateBackground = (obj) => {
  return {
    type: 'UPDATE_BACKGROUND',
    value: obj
  }
}

export const updateObjects = (obj) => {
  return {
    type: 'UPDATE_OBJECTS',
    value: obj
  }
}

/* ---- PAGE ---- */

export const togglePage = () => {
  return {
    type: 'TOGGLE_PAGE'
  }
}

export const openPage = () => {
  return {
    type: 'OPEN_PAGE'
  }
}

export const closePage = () => {
  return {
    type: 'CLOSE_PAGE'
  }
}

export const updatePageContent = (obj) => {
  return {
    type: 'UPDATE_PAGE_CONTENT',
    value: obj
  }
}

export const clearPage = () => {
  return {
    type: 'CLEAR_PAGE'
  }
}

export const showPage = (uid, open) => {
  // console.log(`action: showPage: %c${open}`, 'font-weight:bold')
  return function (dispatch) {
    const apiCall = new Api()

    if (open) {
      dispatch(closePage())
      dispatch(clearPage())
      setTimeout(() => {
        dispatch(openPage())
        return apiCall.getPage('page', uid)
          .then(result => {
            dispatch(updatePageContent(result.response))
          })
          .catch(error => {
            throw (error)
          })
      }, 200)
    } else {
      dispatch(clearPage())
      dispatch(openPage())
      return apiCall.getPage('page', uid)
        .then(result => {
          dispatch(updatePageContent(result.response))
        })
        .catch(error => {
          throw (error)
        })
    }
  }
}

/* ---- COMMON ---- */
export const updateAll = (obj) => {
  // console.log('updateNav')
  return {
    type: 'UPDATE_ALL',
    value: obj
  }
}

export const startLoading = () => {
  return {
    type: 'START_LOADING'
  }
}

export const endLoading = () => {
  return {
    type: 'END_LOADING'
  }
}
